<ul class="folder-content-container">
  @for (item of folderContent.items; track item) {
    <li
      class="item"
      (click)="handleOnClickRow(item)"
      (keydown.enter)="handleOnClickRow(item)"
    >
      <gc-icon
        [iconName]="item.type === 'FOLDER' ? 'folder' : 'file'"
        [color]="item.type === 'FOLDER' ? 'caution' : 'primary'"
      ></gc-icon>
      <div class="text-container">
        <gc-text [variant]="'body'">{{ item.name }}</gc-text>
        <div class="item-data-container">
          <gc-text [variant]="'information'" [textColor]="'secondary'"
            >{{ formatDate(item.modifiedAt) }} |
            {{ item.sizeLabel.toUpperCase() }}</gc-text
          >
          @if (item.childCount > 0) {
            <gc-text [variant]="'information'" [textColor]="'secondary'"
              >- {{ item.childCount }} {{ 'objects' | translate }}</gc-text
            >
          }
        </div>
      </div>
      <button class="action-button" (click)="handleOnClickIcon(item)">
        <gc-icon
          [iconName]="item.type === 'FOLDER' ? 'chevronRight' : 'download'"
        ></gc-icon>
      </button>
    </li>
  }
</ul>
